import React, { createContext, useRef } from 'react';

// Create a context to share the ChatSupport component ref
export const ChatSupportContext = createContext(null);

// Provider component to wrap around components that need access to the chat
export const ChatSupportProvider = ({ children }) => {
  const chatSupportRef = useRef(null);

  return (
    <ChatSupportContext.Provider value={{ chatSupportRef }}>
      {children}
    </ChatSupportContext.Provider>
  );
}; 